
import { TAGLINE_DATA_SELECTOR_ATTRIBUTE_FOR_SEO } from '../../Landing.constants'

export default {
  props: {
    title: { type: String, required: true },
    tagline: { type: String, default: undefined },
  },
  computed: {
    TAGLINE_DATA_SELECTOR_ATTRIBUTE_FOR_SEO: () =>
      TAGLINE_DATA_SELECTOR_ATTRIBUTE_FOR_SEO,
  },
}
